import { useCallback } from 'react';

import type { QueryObject, RouterProps } from 'interface/queryParam';
import { parseQuery, unParseQuery } from 'utils/string';

type QueryRouterProps = Partial<RouterProps>;
type QueryHistory = QueryRouterProps['history'];

const getURLQuery = (props: QueryRouterProps): QueryObject => {
  return parseQuery(props.location?.search || '');
};

const setURLQuery = (history: QueryHistory, search: string | undefined, query: QueryObject): void => {
  let currentQuery: QueryObject = parseQuery(search || '');
  currentQuery = { ...currentQuery, ...query };

  history?.push({
    search: unParseQuery(currentQuery),
  });
};

const useQuery = <TProps extends object>(
  props: TProps,
  initialState: QueryObject = {}
): [QueryObject, (query: QueryObject) => void] => {
  const routerProps = props as QueryRouterProps;
  const query = getURLQuery(routerProps) || initialState;
  const history = routerProps.history;
  const search = routerProps.location?.search;

  const setQuery = useCallback(
    (nextQuery: QueryObject): void => {
      setURLQuery(history, search, nextQuery);
    },
    [history, search]
  );

  return [query, setQuery];
};

export default useQuery;
